import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// core components
import Navbar from "./layouts/Navbar.js";
import Footer from "./layouts/Footer.js";

import '../assets/css/Service.css'

// Image import
import overviewImg4 from '../assets/img/overview_img4.png';

import technologyImg5 from '../assets/img/technology_img5.png';
import technologyImg6 from '../assets/img/technology_img6.png';

import technologyImg7 from '../assets/img/technology_img7.jpg';
import technologyImg8 from '../assets/img/technology_img8.jpg';
import technologyImg9 from '../assets/img/technology_img9.jpg';

export default function UAM() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'ko';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  return (
    <>
    <Navbar />
    <div className="wrapper">

      <div id="UAMHeader" className="Hero">
        <div className="HeaderSection fadeDivide">
          <div className="HeaderSectionTxtBox">
            <div className="HeaderSectionSubTitle">시뮬레이터</div>
            <div className="HeaderSectionTitle">ASTRONAV</div>
            <div className="HeaderSectionTxt">Urban Air Mobility</div>
          </div>
        </div>
      </div>

      <div id="Overview_UAM">
        <div className="Section">
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark fadeDivide">Overview</div>
              <div className="SectionHeaderTitle fadeDivide" style={{lineHeight:'50px'}}>
                <span className="SectionHeaderTitleDesc fadeDivide">UAM 분야 최고의 기술역량 확보<br/></span>
                <span>수요자 중심의 온디맨드 UAM 어플리케이션 기술개발 선도주자</span>
              </div>
              <div className="SectionHeaderDescription">
                <span></span>
              </div>
            </div>
          </div>
          <div className="SectionContents">
            <img className="uamImg_Full fadeDivide" src={overviewImg4} alt="UAM Service Overview"/>
            <img className="uamImg_Full fadeDivide" src={technologyImg5} alt="UAM Service Overview"/>
          </div>
        </div>
      </div>

      <div id="Technology_UAM">
        <div className="Section">
          <div className="SectionHeaderFull fadeDivide">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark">Technology</div>
              <div className="SectionHeaderTitle" style={{lineHeight:'50px'}}>
                <span className="SectionHeaderTitleDesc">UAM 시험센터의 후보지 검토, 운영계획 수립, 공연 분석 등 전문 분야 포함<br/></span>
                <span>모든 분야를 총괄하는 UAM 어플리케이션 아키텍쳐 보유</span>
              </div>
              <img className="uamImg_Full fadeDivide" src={technologyImg6} alt="UAM Service Architecture"/>
              </div>
          </div>
          <div className="SectionContents">
            <div className="multipleImgBox">
              <div className="ImgWithTitle fadeDivide">
                <img className="uamImg_Multiple" src={technologyImg7} alt="UAM Technology"/>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="uamImg_Multiple" src={technologyImg8} alt="UAM Technology"/>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="uamImg_Multiple" src={technologyImg9} alt="UAM Technology"/>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
    </>
  )
};